export enum OfficeTabCode {
  INFO = 'info',
  ACTORS = 'actors',
  SUBCONTRACTS = 'subcontracts',
  NOTIFICATION = 'notification',
  DOSSIER = 'dossier',
  CHAT = 'chat',
  ACCOUNTING_REPORTS = 'accounting-reports',
  ACCESS_CONTROL = 'access-control',
  ATTENDANCE_REGISTER = 'attendance-register',
  CONSTRUCTION_MANAGEMENT = 'construction-management',
}

export enum OfficeTabLabel {
  INFO = 'Info',
  ACTORS = 'Attori',
  SUBCONTRACTS = 'Documentazione di cantiere',
  NOTIFICATION = 'Notifica',
  DOSSIER = 'Pratica',
  OFFICE = 'Chat operativa',
  ACCOUNTING_REPORTS = `Rapportini`,
  ACCESS_CONTROL = 'Controllo accessi',
  ATTENDANCE_REGISTER = 'Registro presenze',
  CONSTRUCTION_MANAGEMENT = `Gestione di cantiere`
}
